module.exports = __webpack_public_path__ + "img/icon_fzxm@2x.c5af7f80.png";